<main class="h-full flex flex-col items-center justify-center">
    <img alt="RKSH Regjistri i kafshëve shtëpiake" class="max-w-full !relative !h-auto mb-4 -mt-24" height="100"
    src="https://ctvmngvzsmtrbqckpgxq.supabase.co/storage/v1/object/public/assets/logo-small.png">
    <section>
        <p-card class="sign-in-wrapper flex flex-row items-center justify-center p-4">
            <form class="w-full" [formGroup]="form" (ngSubmit)="login()">
                <div class="mb-4">
                    <div class="flex flex-col gap-2">
                        <label for="email">{{ "signIn.emailFieldLabel" | translate }}*</label>
                        <input formControlName="email" id="email" pInputText type="email" [placeholder]="'signIn.emailFieldPlaceholder' | translate" />
                        @if (!form.get('email')?.valid && form.touched) {
                            @if (form.get('email')?.errors?.['required']) {
                                <p-message severity="error" size="small" variant="simple">{{ "signIn.emailRequired" | translate}}</p-message>
                            }
                            @if (form.get('email')?.errors?.['email']) {
                                <p-message severity="error" size="small" variant="simple">{{ "signIn.emailNotValid" | translate}}</p-message>
                            }
                        }
                    </div>
                </div>
                <div class="mb-4">
                    <div class="flex flex-col gap-2">
                        <label for="passwordRepeat">{{ "signIn.passwordFieldLabel" | translate }}*</label>
                        <p-password autocomplete="off" fluid formControlName="password" id="passwordRepeat" [feedback]="false" [placeholder]="'signIn.passwordFieldPlaceholder' | translate" [toggleMask]="true" />
                    </div>
                </div>
                <p>
                    <p-button styleClass="w-full" type="submit" [disabled]="!form.valid">{{ "common.loginButtonText" | translate}}</p-button>
                </p>
            </form>
        </p-card>
    </section>
</main>
